/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }]*/
import { fetchJson, postFile } from './core/ajax-json.js';
import { pushBack, push } from './store/history.js';
import { locale } from './store/cookies.js';
import notifications from './notifications.js';

function insertDocument(element, doc) {
	const dateTemplate = element.getElementsByClassName('js-template-document-date')[0];
	const infoTemplate = element.getElementsByClassName('js-template-document-info')[0];
	const newDateElement = dateTemplate.cloneNode(true);
	newDateElement.classList.remove('u-hide');

	const date = new Date(doc.playerTimestamp);
	newDateElement.getElementsByTagName('small')[0].innerHTML = date.toLocaleDateString(locale()
		.replace('_', '-'), {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			second: 'numeric'
		});

	// Only possible to delete approved documents
	if (doc.state === '1') {
		const removeButton = newDateElement.getElementsByClassName('js-remove-button')[0];
		removeButton.dataset.id = doc.id;
		removeButton.classList.remove('u-hide');
	}

	const newInfoElement = infoTemplate.cloneNode(true);
	newInfoElement.getElementsByClassName('js-filename')[0].innerHTML = doc.filename;
	newInfoElement.getElementsByClassName('js-status')[0].innerHTML = doc.status;

	newInfoElement.classList.remove('u-hide');

	infoTemplate.parentNode.insertBefore(newDateElement, infoTemplate.nextSibling);
	newDateElement.parentNode.insertBefore(newInfoElement, newDateElement.nextSibling);
}

function setTextAndIcon(numberOfDocuments, element) {
	const mainTitle = element.getElementsByClassName('js-main-title')[0];
	const supportTitle = element.getElementsByClassName('js-support-title')[0];
	const iconDiv = element.getElementsByClassName('js-icon')[0];
	const hasDocumentsIcon = iconDiv.getElementsByClassName('js-has-documents')[0];
	const emptyDocumentsIcon = iconDiv.getElementsByClassName('js-empty-documents')[0];
	if (numberOfDocuments > 0) {
		mainTitle.innerHTML = mainTitle.dataset.existsText;
		supportTitle.innerHTML = supportTitle.dataset.existsText;
		hasDocumentsIcon.classList.remove('u-hide');
		emptyDocumentsIcon.classList.add('u-hide');
	} else {
		mainTitle.innerHTML = mainTitle.dataset.emptyText;
		supportTitle.innerHTML = supportTitle.dataset.emptyText;
		hasDocumentsIcon.classList.add('u-hide');
		emptyDocumentsIcon.classList.remove('u-hide');
	}
}

function fetchUploadedDocuments(element) {
	fetchJson('/doc')
		.then((response) => {
			const table = element.getElementsByClassName('js-documents-table')[0];
			const tableRows = table.getElementsByTagName('tr');
			const removeNodes = [];
			for (let i = 0; i < tableRows.length; i++) {
				const tableRow = tableRows[i];
				if (tableRow.classList.contains('u-hide') === false) {
					removeNodes.push(tableRow);
				}
			}

			const parent = tableRows[0].parentNode;
			for (let i = 0; i < removeNodes.length; i++) {
				const removeNode = removeNodes[i];
				parent.removeChild(removeNode);
			}

			setTextAndIcon(response.result.length, element);
			for (let i = response.result.length - 1; i >= 0; i--) {
				const doc = response.result[i];
				insertDocument(element, doc);
			}
			const removeButtons = element.getElementsByClassName('js-remove-button');
			for (let i = 0; i < removeButtons.length; i += 1) {
				removeButtons[i].onclick = (event) => {
					const headers = new Headers();
					headers.append('Content-Type', 'application/json');
					const options = {
						headers,
						method: 'DELETE',
						credentials: 'include',
						body: event.currentTarget.dataset.id
					};

					fetch('/doc', options)
						.then(() => {
							fetchUploadedDocuments(element);
						});
				};
			}
		});
}

function bindBackButton(element, doneCallback) {
	const backButtonElement = element.getElementsByClassName('icon-close')[0];
	backButtonElement.onclick = () => {
		doneCallback();
	};
}

function uploadDocument(file, element) {
	postFile('/doc', file)
		.then((response) => {
			if (response.status === 'SUCCESS') {
				fetchUploadedDocuments(element);
			} else {
				notifications.showNotification(response.errorDescription, 'red', true);
			}
		})
		.catch((e) => {
			console.error('upload-documents:Post url-encoded form failed. error:', e);
			return Promise.reject(e);
		});
}

function bindUploadButton(element) {
	const uploadButtonElement = element.getElementsByClassName('js-upload-button')[0];
	uploadButtonElement.onchange = () => {
		uploadDocument(uploadButtonElement.files[0], element);
	};
}

function setBackIcon(element) {
	element.getElementsByClassName('icon-close')[0].classList.add('icon-close--back');
}

function init(referrer) {
	const template = document.getElementsByClassName('upload-menu')[0];
	const newElement = template.cloneNode(true);

	if (referrer) {
		bindBackButton(newElement, () => {
			push('/account');
		});
	} else {
		// if page has not a referrer show back button, bind push back
		setBackIcon(newElement);

		bindBackButton(newElement, () => {
			pushBack();
		});
	}

	bindUploadButton(newElement);
	fetchUploadedDocuments(newElement);
	newElement.classList.remove('u-hide');
	template.parentNode.insertBefore(newElement, template);
	newElement.classList.add('menu--is-open');
	newElement.classList.add('u-transform-none');
	return newElement;
}

function setCloseIcon(element) {
	element.getElementsByClassName('icon-close')[0].classList.remove('icon-close--back');
}

function view(viewReadyPromise) {
	let viewDoneResolver;
	const viewDonePromise = new Promise((resolve) => {
		viewDoneResolver = resolve;
	});

	viewReadyPromise.then((contextElement) => {
		setCloseIcon(contextElement);
		fetchUploadedDocuments(contextElement);
		bindBackButton(contextElement, () => {
			viewDoneResolver({ status: 'close' });
		});
		bindUploadButton(contextElement);
	});

	const element = (document.getElementsByClassName('upload-menu')[0]).cloneNode(true);
	return Promise.resolve({
		html: element.innerHTML,
		viewDonePromise
	});
}

function fetchHasDocuments() {
	return new Promise((resolve) => {
		fetchJson('/doc')
			.then((response) => {
				resolve(response.result.length > 0);
			});
	});
}

function setAccountLinkUploadDocumentsIcon() {
	fetchHasDocuments()
		.then((hasDocuments) => {
			const uploadDocumentLink = document.getElementsByClassName('js-upload-documents-link')[0];
			if (hasDocuments) {
				uploadDocumentLink.getElementsByClassName('js-has-documents')[0].classList.remove('u-hide');
				uploadDocumentLink.getElementsByClassName('js-empty-documents')[0].classList.add('u-hide');
			} else {
				uploadDocumentLink.getElementsByClassName('js-has-documents')[0].classList.add('u-hide');
				uploadDocumentLink.getElementsByClassName('js-empty-documents')[0].classList.remove('u-hide');
			}
		});
}

export default {
	view,
	init,
	setAccountLinkUploadDocumentsIcon,
	fetchHasDocuments
};



// WEBPACK FOOTER //
// ./mobile-core/src/upload-documents.js